import { call, put, takeLatest } from 'redux-saga/effects';
import { Map, List } from 'immutable';
import { Notification } from '@utils';
import {
  getFolgas as getFolgasSdk,
  getFolga as getFolgaSdk,
  postFolgas as postFolgasSdk,
  putFolgas as putFolgasSdk,
  deleteFolgas as deleteFolgasSdk,
} from '@sdk/Conectores/Folgas';

//Action Types
export const Types = {
  GET_FOLGAS: 'GET_FOLGAS',
  GET_FOLGAS_SUCCESS: 'GET_FOLGAS_SUCCESS',
  GET_FOLGAS_ERROR: 'GET_FOLGAS_ERROR',

  GET_FOLGA: 'GET_FOLGA',
  GET_FOLGA_SUCCESS: 'GET_FOLGA_SUCCESS',
  GET_FOLGA_ERROR: 'GET_FOLGA_ERROR',

  PUT_FOLGAS: 'PUT_FOLGAS',
  PUT_FOLGAS_SUCCESS: 'PUST_FOLGAS_SUCCESS',
  PUT_FOLGAS_ERROR: 'PUT_FOLGAS_ESRROR',

  POST_FOLGAS: 'POST_FOLGAS',
  POST_FOLGAS_SUCCESS: 'POST_FOLGAS_SUCCESS',
  POST_FOLGAS_ERROR: 'POST_FOLGAS_ERROR',

  DELETE_FOLGAS: 'DELETE_FOLGAS',
  DELETE_FOLGAS_SUCCESS: 'DELETE_FOLGAS_SUCCESS',
  DELETE_FOLGAS_ERROR: 'DELETE_FOLGAS_ERROR',

  SET_FOLGAS_CONECTORES_SELECIONADOS: 'SET_FOLGAS_CONECTORES_SELECIONADOS',

  RESET_FOLGAS: 'RESET_FOLGAS',
};

//Action Creators
export const getFolgas = () => ({ type: Types.GET_FOLGAS });
export const getFolgasSuccess = (data) => ({ type: Types.GET_FOLGAS_SUCCESS, data });
export const getFolgasError = (error) => ({ type: Types.GET_FOLGAS_ERROR, error });

export const getFolga = (id) => ({ type: Types.GET_FOLGA, id });
export const getFolgaSuccess = (folga) => ({ type: Types.GET_FOLGA_SUCCESS, folga });
export const getFolgaError = (error) => ({ type: Types.GET_FOLGA_ERROR, error });

export const postFolgas = (data) => ({ type: Types.POST_FOLGAS, data });
export const postFolgasSuccess = () => ({ type: Types.POST_FOLGAS_SUCCESS });
export const postFolgasError = (error) => ({ type: Types.POST_FOLGAS_ERROR, error });

export const putFolgas = (data) => ({ type: Types.PUT_FOLGAS, data });
export const putFolgasSuccess = () => ({ type: Types.PUT_FOLGAS_SUCCESS });
export const putFolgasError = (error) => ({ type: Types.PUT_FOLGAS_ERROR, error });

export const deleteFolgas = (id) => ({ type: Types.DELETE_FOLGAS, id });
export const deleteFolgasSuccess = () => ({ type: Types.DELETE_FOLGAS_SUCCESS });
export const deleteFolgasError = (error) => ({ type: Types.DELETE_FOLGAS_ERROR, error });

export const setConectoresSelecionados = (conectoresSelecionados) => ({
  type: Types.SET_FOLGAS_CONECTORES_SELECIONADOS,
  conectoresSelecionados,
});

export const reset = () => ({ type: Types.RESET_FOLGAS });

//saga

function* fetchGetFolgas(action) {
  try {
    const folgas = yield call(getFolgasSdk);
    yield put(getFolgasSuccess(folgas));
  } catch (err) {
    Notification.error(err.message);
    yield put(getFolgasError(err));
  }
}

function* fetchGetFolga(action) {
  try {
    const folga = yield call(getFolgaSdk, action.id);
    yield put(getFolgaSuccess(folga));
  } catch (err) {
    Notification.error(err.message);
    yield put(getFolgaError(err));
  }
}

function* fetchPutFolgas(action) {
  try {
    yield call(putFolgasSdk, action.data);
    yield put(putFolgasSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(putFolgasError(err));
  }
}

function* fetchPostFolgas(action) {
  try {
    yield call(postFolgasSdk, action.data);
    yield put(postFolgasSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(postFolgasError(err));
  }
}

function* fetchDeleteFolgas(action) {
  try {
    const { id } = action;
    yield call(deleteFolgasSdk, id);
    yield put(deleteFolgasSuccess(id));
  } catch (err) {
    Notification.error(err.message);
    yield put(deleteFolgasError(err));
  }
}

export const saga = [
  takeLatest(Types.GET_FOLGAS, fetchGetFolgas),
  takeLatest(Types.GET_FOLGA, fetchGetFolga),
  takeLatest(Types.PUT_FOLGAS, fetchPutFolgas),
  takeLatest(Types.POST_FOLGAS, fetchPostFolgas),
  takeLatest(Types.DELETE_FOLGAS, fetchDeleteFolgas),
];

// Reducer
const initialState = Map({
  folgas: List(),
  folga: {},
  conectoresSelecionados: [],

  loadingFolgas: false,
  successFolgas: false,
  errorFolgas: false,

  loadingFolga: false,
  successFolga: false,
  errorFolga: false,

  puttingFolgas: false,
  successPutFolgas: false,
  errorPutFolgas: false,

  postingFolgas: false,
  successPostFolgas: false,
  errorPostFolgas: false,

  deletingFolgas: false,
  successDeleteFolgas: false,
  errorDeleteFolgas: false,
});

const handleGetFolgas = (state, action) => {
  return state.set('loadingFolgas', true).set('successFolgas', false).set('errorFolgas', false);
};

const handleGetFolgasSuccess = (state, action) => {
  const { data } = action;

  return state.set('folgas', List(data)).set('loadingFolgas', false).set('successFolgas', true).set('errorFolgas', false);
};

const handleGetFolgasError = (state, action) => {
  return state.set('loadingFolgas', false).set('successFolgas', false).set('errorFolgas', action.error);
};

const handleGetFolga = (state, action) => {
  return state.set('loadingFolga', true).set('successFolga', false).set('errorFolga', false);
};

const handleGetFolgaSuccess = (state, action) => {
  const { folga } = action;

  let conectoresSelecionados = folga[0].conectoresSelecionados.split(',');

  if (conectoresSelecionados[0] === '') conectoresSelecionados = [];

  return state
    .set('folga', folga[0])
    .set('loadingFolga', false)
    .set('successFolga', true)
    .set('errorFolga', false)
    .set('conectoresSelecionados', conectoresSelecionados);
};

const handleGetFolgaError = (state, action) => {
  return state.set('loadingFolga', false).set('successFolga', false).set('errorFolga', action.error);
};

const handlePutFolgas = (state, action) => {
  return state.set('puttingFolgas', true).set('successPutFolgas', false).set('errorPutFolgas', false);
};

const handlePutFolgasSuccess = (state, action) => {
  return state.set('puttingFolgas', false).set('successPutFolgas', true).set('errorPutFolgas', false);
};

const handlePutFolgasError = (state, action) => {
  return state.set('puttingFolgas', false).set('successPutFolgas', false).set('errorPutFolgas', action.error);
};

const handlePostFolgas = (state, action) => {
  return state.set('postingFolgas', true).set('successPostFolgas', false).set('errorPostFolgas', false);
};

const handlePostFolgasSuccess = (state, action) => {
  return state.set('posttingFolgas', false).set('successPostFolgas', true).set('errorPostFolgas', false);
};

const handlePostFolgasError = (state, action) => {
  return state.set('posttingFolgas', false).set('successPostFolgas', false).set('errorPostFolgas', action.error);
};

const handleConectoresSelecionados = (state, action) => {
  const { conectoresSelecionados } = action;
  return state.set('conectoresSelecionados', conectoresSelecionados);
};

const handleDeleteFolgas = (state, action) => {
  return state.set('deletingFolgas', true).set('successDeleteFolgas', false).set('errorDeleteFolgas', false);
};

const handleDeleteFolgasSuccess = (state, action) => {
  return state.set('deletingFolgas', false).set('successDeleteFolgas', true).set('errorDeleteFolgas', false);
};

const handleDeleteFolgasError = (state, action) => {
  return state.set('deletingFolgas', false).set('successDeleteFolgas', false).set('errorDeleteFolgas', action.error);
};

const handleReset = (state, action) => {
  state = initialState;
  return state;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_FOLGAS:
      return handleGetFolgas(state, action);
    case Types.GET_FOLGAS_SUCCESS:
      return handleGetFolgasSuccess(state, action);
    case Types.GET_FOLGAS_ERROR:
      return handleGetFolgasError(state, action);

    case Types.GET_FOLGA:
      return handleGetFolga(state, action);
    case Types.GET_FOLGA_SUCCESS:
      return handleGetFolgaSuccess(state, action);
    case Types.GET_FOLGA_ERROR:
      return handleGetFolgaError(state, action);

    case Types.POST_FOLGAS:
      return handlePostFolgas(state, action);
    case Types.POST_FOLGAS_SUCCESS:
      return handlePostFolgasSuccess(state, action);
    case Types.POST_FOLGAS_ERROR:
      return handlePostFolgasError(state, action);

    case Types.PUT_FOLGAS:
      return handlePutFolgas(state, action);
    case Types.PUT_FOLGAS_SUCCESS:
      return handlePutFolgasSuccess(state, action);
    case Types.PUT_FOLGAS_ERROR:
      return handlePutFolgasError(state, action);

    case Types.DELETE_FOLGAS:
      return handleDeleteFolgas(state, action);
    case Types.DELETE_FOLGAS_SUCCESS:
      return handleDeleteFolgasSuccess(state, action);
    case Types.DELETE_FOLGAS_ERROR:
      return handleDeleteFolgasError(state, action);

    case Types.SET_FOLGAS_CONECTORES_SELECIONADOS:
      return handleConectoresSelecionados(state, action);

    case Types.RESET_FOLGAS:
      return handleReset(state, action);

    default:
      return state;
  }
}
